import { Card, Tag, Button, Typography, Flex, App, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { deleteQuestion, getQuestions } from "../../redux/slices/QuestionBankSlice";
import { useDispatch } from "react-redux";

const { Text } = Typography;

const QuestionCard = ({ question, setOpenModal, setSelectedQuestion }) => {
    const { message } = App.useApp();
    const dispatch = useDispatch();

    const handleDelete = async () => {
        const res = await dispatch(deleteQuestion(question?.questionId));
        if (res?.payload?.statusCode === 201) {
            dispatch(getQuestions());
            message.success("Question deleted successfully");
        }
    };

    const handleEdit = () => {
        setOpenModal(true);
        setSelectedQuestion(question);
    };

    return (
        <Card className="question-card">
            {/* Tags */}
            <Flex className="qc-tags">
                <Tag color="blue">{question?.questionTypeName}</Tag>
                {question?.isRequired ? (
                    <Tag color="red">Required</Tag>
                ) : (
                    <Tag color="default">Optional</Tag>
                )}
            </Flex>

            {/* Title */}
            <Text strong>{question?.questionTitle}</Text><br />
            <Text type="secondary">
                {question?.description}
            </Text>

            {/* Chips */}
            <Flex className="qc-chips" wrap>
                {question?.entityTypes?.map((entity) => (
                    <Tag color="cyan" key={entity.entityTypeId}>{entity.entityTypeName}</Tag>
                ))}
            </Flex>

            {/* Actions */}
            <div className="qc-actions">
                <Button icon={<EditOutlined />} block onClick={handleEdit}>
                    Edit
                </Button>

                <Popconfirm
                    title="Delete Question"
                    description="Are you sure you want to delete this question?"
                    onConfirm={handleDelete}
                    onCancel={() => { }}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button danger icon={<DeleteOutlined />} />
                </Popconfirm>
            </div>

            <Text type="secondary" className="qc-id">
                ID: {question?.questionId}
            </Text>
        </Card>
    );
};

export default QuestionCard;